"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.board = initialState || Array(4).fill().map(()=>Array(4).fill(0));
        this.score = 0;
        this.status = "idle"; // 'idle', 'playing', 'win', 'lose'
    }
    getState() {
        return this.board;
    }
    getScore() {
        return this.score;
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.board = Array(4).fill().map(()=>Array(4).fill(0));
        this.score = 0;
        this.status = "playing";
        this.addRandomTile();
        this.addRandomTile();
    }
    restart() {
        this.start();
    }
    moveLeft() {
        let moved = false;
        this.board = this.board.map((row)=>{
            const filtered = row.filter((v)=>v !== 0);
            for(let i = 0; i < filtered.length - 1; i++)if (filtered[i] === filtered[i + 1]) {
                filtered[i] *= 2;
                this.score += filtered[i];
                filtered[i + 1] = 0;
                moved = true;
            }
            const newRow = filtered.filter((v)=>v !== 0);
            while(newRow.length < 4)newRow.push(0);
            if (!moved && row.toString() !== newRow.toString()) moved = true;
            return newRow;
        });
        if (moved) this.addRandomTile();
        this.checkGameState();
    }
    moveRight() {
        this.board = this.board.map((row)=>row.reverse());
        this.moveLeft();
        this.board = this.board.map((row)=>row.reverse());
    }
    moveUp() {
        this.transpose();
        this.moveLeft();
        this.transpose();
    }
    moveDown() {
        this.transpose();
        this.moveRight();
        this.transpose();
    }
    addRandomTile() {
        const emptyCells = [];
        this.board.forEach((row, i)=>{
            row.forEach((cell, j)=>{
                if (cell === 0) emptyCells.push({
                    i: i,
                    j: j
                });
            });
        });
        if (emptyCells.length > 0) {
            const { i: i, j: j } = emptyCells[Math.floor(Math.random() * emptyCells.length)];
            this.board[i][j] = Math.random() < 0.9 ? 2 : 4;
        }
    }
    checkGameState() {
        if (this.board.flat().includes(2048)) {
            this.status = "win";
            return;
        }
        const movesAvailable = this.board.some((row, i)=>{
            return row.some((cell, j)=>{
                return cell === 0 || j < 3 && cell === this.board[i][j + 1] || i < 3 && cell === this.board[i + 1][j];
            });
        });
        if (!movesAvailable) this.status = "lose";
    }
    transpose() {
        this.board = this.board[0].map((_, i)=>this.board.map((row)=>row[i]));
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$cells = document.querySelectorAll(".field-cell");
const $09e991522ca7e64e$var$scoreElement = document.querySelector(".game-score");
const $09e991522ca7e64e$var$startButton = document.querySelector(".button.start");
const $09e991522ca7e64e$var$messages = {
    start: document.querySelector(".message-start"),
    win: document.querySelector(".message-win"),
    lose: document.querySelector(".message-lose")
};
function $09e991522ca7e64e$var$updateUI() {
    const board = $09e991522ca7e64e$var$game.getState();
    $09e991522ca7e64e$var$cells.forEach((cell, index)=>{
        const x = Math.floor(index / 4);
        const y = index % 4;
        const value = board[x][y];
        cell.className = "field-cell";
        if (value > 0) cell.classList.add(`field-cell--${value}`);
        cell.textContent = value || "";
    });
    $09e991522ca7e64e$var$scoreElement.textContent = $09e991522ca7e64e$var$game.getScore();
    Object.keys($09e991522ca7e64e$var$messages).forEach((key)=>{
        $09e991522ca7e64e$var$messages[key].classList.add("hidden");
    });
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") $09e991522ca7e64e$var$messages.start.classList.remove("hidden");
    else if ($09e991522ca7e64e$var$game.getStatus() === "win") $09e991522ca7e64e$var$messages.win.classList.remove("hidden");
    else if ($09e991522ca7e64e$var$game.getStatus() === "lose") $09e991522ca7e64e$var$messages.lose.classList.remove("hidden");
    if ($09e991522ca7e64e$var$game.getStatus() === "playing" || $09e991522ca7e64e$var$game.getStatus() === "lose") $09e991522ca7e64e$var$startButton.textContent = "Restart";
    else $09e991522ca7e64e$var$startButton.textContent = "Start";
    $09e991522ca7e64e$var$startButton.classList.add("restart");
}
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$updateUI();
});
document.addEventListener("keydown", (ev)=>{
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    switch(ev.key){
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            return;
    }
    $09e991522ca7e64e$var$updateUI();
});


//# sourceMappingURL=index.e13d3444.js.map
